var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('error-content',{attrs:{"code":_vm.$t('pageislost'),"desc":"The page you`re looking for is not here.","src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }